import request from '@/utils/zsm-requets'
const good='/zsm/api/good/'
import Qs from 'qs'
// 新建一个课程
/**
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态


 **/

export function createGood(params) {
  return request({
    url: good+'create',
    method: 'post',
     data: Qs.stringify(params)
    // headers:{'Content-Type':'application/x-www-form-urlencoded'}
    // params
  })
}

/** 删除Qs课程
@param id		课程id	 **/
export function deleteGood(id) {
  return request({
    url:good+'delete',
    method: 'post',
    params:{id}
  })
}

/*
  修改上下架
  id 课程id
  shelfFlag 上下架

 */
export function updateShelfFlag(params) {
  return request({
    url: good+'updateShelfFlag',
    method: 'post',
    params
  })
}



/** 查看课程的章节
@param id		课程id	 **/
export function listChildrenGood(params) {
  return request({
    url: good+'listChildren',
    method: 'post',
     params
	 // :{'goodId.id':id}
  })
}




/**获取课程列表
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态
 **/
export function listDataGood(params) {
  return request({
    url: good+'listData',
    method: 'post',
     params
  })
}



/** 查看课程的分组
@param id		课程id	 **/
export function listGroupGood(tempGoodId) {
  return request({
    url: good+'listGroup',
    method: 'post',
     params:{tempGoodId}
  })
}




// 修改一个课程
/**
@param auditDesc	审核说明
@param auditProgress	审核状态
@param bindTitle	挂载标题
@param buyCount	购买数
@param childAudit	章节待审核数
@param childCount	章节数
@param classifyFullName	完整分类名称
@param cloudCode	云盘提取码
@param cloudDict	云盘类型
@param cloudUrl	云盘地址
@param commentCount	评论数
@param contentCover	详情封面
@param cover	列表封面
@param defendFlag	防截屏
@param distCustomFlag	是否分销
@param hotCount	热度
@param mixContent	图文内容
@param platformDicts	审核说明
@param price	单价
@param publicFlag	上架标记
@param subTitle	副标题
@param title	标题
@param frontId	前端id
@param shopId	 门店id
@param sort	 排序
@param progress	 审核状态
 **/
export function updateGood(params) {
  return request({
    url: good+'update',
    method: 'post',
    data: Qs.stringify(params)
  })
}

// 获取课程 id课程id  viewFlag是否增加观看数
export function getGood(id) {
  return request({
    url: good+'get',
    method: 'post',
    params:{viewFlag:0,id}
  })
}

// 创建分组  goodId课程id   name内容
export function createGroup(tempGoodId,name) {
  return request({
    url: good+'createGroup',
    method: 'post',
    params:{tempGoodId,name}
  })
}

// 删除分组  id分组id
export function deleteGroup(id) {
  return request({
    url: good+'deleteGroup',
    method: 'post',
    params:{id}
  })
}


// 修改分组
export function updateGroup(params) {
  return request({
    url: good+'updateGroup',
    method: 'post',
    params
  })
}


//修改版权内容 copyRightNote版权内容 id课程id
export function updateCopyRight(copyRightNote,id) {
  return request({
    url: good+'updateCopyRight',
    method: 'post',
    params:{copyRightNote,id}
  })
}

/*

  创建章节
  goodGroupId 分组编号
  goodGroupName 分组名称
  tempGoodId 商品id
  title 标题
  mediaDict 媒体类型
  mediaUrl 	媒体地址
  shelfFlag 	上下架,0=下架，1=上架
  auditProgress 审核状态
  sort 分组名称
 */
export function createDetail(params) {
  return request({
    url: good+'createDetail',
    method: 'post',
    data:Qs.stringify(params)
  })
}



/*

  修改章节
  auditProgress 审核状态
  title 标题
  mediaDict 媒体类型
  mediaUrl 	媒体地址
  shelfFlag 	上下架,0=下架，1=上架
  goodGroupId 分组编号
  goodGroupName 分组名称
  sort 分组名称
 */
export function updateDetail(params) {
  return request({
    url: good+'updateDetail',
    method: 'post',
    data:Qs.stringify(params)
  })
}

// 修改章节排序 sort 排序 id章节
export function updateDetailSort(params) {
  return request({
    url: good+'updateDetailSort',
    method: 'post',
    params
  })
}

// 删除章节 id 章节id
export function deleteDetail(id) {
  return request({
    url: good+'deleteDetail',
    method: 'post',
    params:{id}
  })
}

// 修改章节上下架 id 章节id  shelfFlag是否上架
export function updateDetailShelfFlag(id,shelfFlag) {
  return request({
    url: good+'updateDetailShelfFlag',
    method: 'post',
    params:{id,shelfFlag}
  })
}

// 批量更新分组排序 ids	商品分组编号，用逗号隔开
export function updateGroupSorts(ids) {
  return request({
    url: good+'updateGroupSorts',
    method: 'post',
    params:{ids}
  })
}


// 修改章节的是否试看  demoFlag是否试看  id课程编号
export function updateDetailDemoFlag(params) {
  return request({
    url: good+'updateDetailDemoFlag',
    method: 'post',
    params
  })
}

// 修改章节的分组
/*
    groupId 分组id
    groupName 分组名称
    id  课程id
*/
export function updateDetailGroup(params) {
  return request({
    url: good+'updateDetailGroup',
    method: 'post',
    params
  })
}


/* 批量提交章节 */
  /* 
  detailIds	detailIds 课程详情id
  goodId	goodId	課程id
     */

export function batchUpdateDetail(params) {
  return request({
    url: good+'batchUpdateDetail',
    method: 'post',
    params
  })
}





/* 获取商品的各个选项 */

export function selectOption() {
  return request({
    url: good+'selectOption',
    method: 'post'
  })
}



